export default "__VITE_ASSET__CoYy3iFC__"